// Lib
import { totalEngagementConfig } from '@/lib/analytics/kpis/pinterest/totalEngagement';
import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerEngagementsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> =
    {
        ...totalEngagementConfig,
        id: 'engagements',
        size: SIZE_FULL,
        tooltip: null,
        loader: MediaViewerKpiLoader
    };
